import { Form, Input, Radio } from 'antd';
import AccionaButton from '../../../../../../../components/AccionaButton';
import AntdRangePicker from '../../../../../../../components/AntdRangePicker';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

const BatchForm = ({ handleCustomSearch, queryKey, version }) => {
  const [batchCodeForm] = Form.useForm();
  const [radioValue, setRadioValue] = useState();
  const intl = useIntl();
  return (
    <Form
      style={{ padding: '10px', width: '150px' }}
      onFinish={() => {
        batchCodeForm.validateFields().then((values) => {
          if (
            values.searchType === 'noBatch' ||
            (values.searchType === 'batch' && values.batchNumber)
          ) {
            handleCustomSearch(
              {
                [queryKey]: !values.batchNumber
                  ? 'null'
                  : version === 1
                  ? values.batchNumber
                  : `like:${values.batchNumber}`,
              },
              'concrete_batch',
            );
          }

          if (!values.searchType) {
            handleCustomSearch({ [queryKey]: undefined }, 'concrete_batch');
          }
        });
      }}
      form={batchCodeForm}
    >
      <Form.Item name="searchType" style={{ marginBottom: '5px' }}>
        <Radio.Group
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            gap: '10px',
          }}
          onChange={({ target }) => {
            setRadioValue(target.value);
          }}
        >
          <Radio
            value="noBatch"
            onClick={() => {
              batchCodeForm.resetFields(['batchNumber']);
            }}
          >
            {intl.formatMessage({
              id: 'pages.quality.normative.traceability.list.batchForm.noBatch',
            })}
          </Radio>
          <Radio value="batch">
            {' '}
            {intl.formatMessage({
              id: 'pages.quality.normative.traceability.list.batchForm.batch',
            })}{' '}
          </Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item name="batchNumber">
        <Input disabled={radioValue !== 'batch'}></Input>
      </Form.Item>
      <AccionaButton
        msg={intl.formatMessage({ id: 'search' })}
        classIcon="icon fas fa-search"
        style={{
          margin: '8px auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          width: '85%',
          flex: 0,
        }}
        className="btn btn-red"
        onClick={() => {
          batchCodeForm.submit();
        }}
      />
      <AccionaButton
        msg={intl.formatMessage({ id: 'uncheck' })}
        classIcon="icon fas fa-window-close"
        style={{
          margin: '8px auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          width: '85%',
          flex: 0,
        }}
        className="btn btn-red"
        onClick={() => {
          setRadioValue(undefined);
          batchCodeForm.resetFields();
          batchCodeForm.submit();
        }}
      />
    </Form>
  );
};

BatchForm.propTypes = {
  handleCustomSearch: PropTypes.func.isRequired,
  queryKey: PropTypes.string.isRequired,
  version: PropTypes.number.isRequired,
};

export const COLUMNS_HEADERS = ({
  recipes,
  structuralElements,
  normative,
  intl,
  version,
}) => {
  return {
    docket_number: {
      align: 'left',
      width: '120px',
      sortable: true,
      searchable: true,
    },
    arriving_date: {
      align: 'center',
      ascSort: true,
      sortable: true,
      title: intl.formatMessage({
        id: 'pages.quality.normative.traceability.list.column.arrivalDate',
      }),
      width: '80px',
      customSearchDropdown: ({ handleCustomSearch }) => (
        <AntdRangePicker
          allowClear
          showTime={false}
          format="DD/MM/YYYY"
          style={{ width: 250 }}
          onChange={(dates) => {
            if (!dates) {
              handleCustomSearch({
                startDate: undefined,
                endDate: undefined,
              });
              return;
            }

            handleCustomSearch({
              startDate: dates[0].format('YYYY-MM-DD'),
              endDate: dates[1].format('YYYY-MM-DD'),
            });
          }}
        />
      ),
    },
    recipe: {
      align: 'center',
      width: '150px',
      sortable: true,
      filterable: true,
      multipleFilter: true,
      filterableData:
        recipes?.reduce((acc, cur, index) => {
          acc[index] = {
            value: cur.recipe,
            label: cur.recipe,
          };
          return acc;
        }, {}) || {},
    },
    structural_element: {
      width: '95px',
      align: 'center',
      //sortable: true,
      filterable: true,
      headerAlign: 'flex-start',
      filterableData:
        structuralElements?.reduce((acc, cur) => {
          acc[cur.id] = {
            value: `${cur.structural_element}`,
            label: `${cur.structural_element}`,
          };
          return acc;
        }, {}) || {},
    },
    detailed_location: {
      //width: '159px',
      align: 'center',
      title: intl.formatMessage({
        id: 'pages.quality.normative.traceability.list.column.detailedLocation',
      }),
    },
    control_type: { align: 'center', sortable: true, width: '80px' },
    concrete_batch: {
      align: 'center',
      sortable: true,
      //searchable: true,
      width: '150px',
      queryKey: version === 1 ? 'concrete_batch_data.batch_code' : 'tag',
      customSearchDropdown: ({ handleCustomSearch }) => {
        const queryKey =
          version === 1 ? 'concrete_batch_data.batch_code' : 'tag';
        return (
          <BatchForm
            handleCustomSearch={handleCustomSearch}
            queryKey={queryKey}
            version={version}
          />
        );
      },
    },
  };
};
